import { connect } from 'react-redux';

export default connect(state => ({ browser: state.browser }));



// WEBPACK FOOTER //
// ./src/components/hoc/withBrowserState.js